import { createPinia, setActivePinia } from 'pinia';

const pinia = createPinia();
setActivePinia(pinia);

export { pinia };
export default pinia;

export { useAppStore } from './stores/app';
